<vwui-header>
    <app-back-header (back)="navigateToList()">
        <h2 a11yPageTitleLevel="1">{{ "PAGE_PROJECT_ANALYSIS_EDIT.title" | translate }}</h2>
    </app-back-header>

  <div class="button-group" slot="action">
    <vwui-button (click)="navigateToList()">
      {{ 'BUTTON.cancel' | translate }}
    </vwui-button>
    <vwui-button class="is-primary" [loading]="isUpdatingDefinition" (click)="updateDefinition()" [disabled]="!isConcept()">
     {{ 'BUTTON.save' | translate }}
    </vwui-button>
  </div>
</vwui-header>

@if (loadingSpinnerService.isSpinnerVisible()) {
  <vwui-spinner></vwui-spinner>
}

@if (categories) {
  @for (category of categories; track trackCategory(categoryIndex, category); let categoryIndex = $index) {
    <div class="pa-category">
      <vwui-table [compactable]="false">
          <div slot="table-title">{{ categoryIndex + 1 }}. {{ category.name }} </div>
          @if (isConcept()) {
              <div slot="table-actions">
                <vwui-btn-icon icon="vwui-chevron-up" (click)="moveCategoryUp(category)" [disabled]="categoryIndex === 0"></vwui-btn-icon>
                <vwui-btn-icon icon="chevron-down" (click)="moveCategoryDown(category)" [disabled]="categoryIndex >= categories.length - 1"></vwui-btn-icon>
                <vwui-btn-icon icon="edit" (click)="openUpdateCategoryModal(category)"></vwui-btn-icon>
                <vwui-btn-icon icon="vwui-trash" (click)="openDeleteCategoryModal(category)"></vwui-btn-icon>
              </div>
          }
        <vwui-table-row>
          <vwui-table-header class="pa-col pa-col--nr">{{ 'COMPONENT.tis.table.column.nr' | translate }}</vwui-table-header>
          <vwui-table-header class="pa-col pa-col--question">{{ 'COMPONENT.tis.table.column.question' | translate }}</vwui-table-header>
          <vwui-table-header class="pa-col pa-col--options"></vwui-table-header>
        </vwui-table-row>
          @for (question of category | categoryGetAllSubCategoryQuestions | async; track trackQuestion(questionIndex, question); let questionIndex = $index) {
              <vwui-table-row>
                  <vwui-table-column class="pa-col pa-col--nr">{{ categoryIndex + 1 }}.{{ questionIndex + 1 }} </vwui-table-column>
                  <vwui-table-column class="pa-col pa-col--question">
                      {{ question.title }}
                  </vwui-table-column>
                  <vwui-table-column class="pa-col pa-col--options">
                      @if (isConcept()) {
                        <vwui-btn-icon icon="vwui-chevron-up" [disabled]="questionIndex === 0" (click)="moveQuestionUp(question, category)"></vwui-btn-icon>
                        <vwui-btn-icon icon="chevron-down" [disabled]="questionIndex >= category.getSubcategoryQuestionCount() - 1" (click)="moveQuestionDown(question, category)"></vwui-btn-icon>
                        <vwui-btn-icon icon="edit" (click)="openUpdateQuestionModal(question)"></vwui-btn-icon>
                        <vwui-btn-icon icon="vwui-trash" (click)="openDeleteQuestionModal(question)"></vwui-btn-icon>
                      } @else {
                        <vwui-btn-icon icon="preview" (click)="openUpdateQuestionModal(question)"></vwui-btn-icon>
                      }
                  </vwui-table-column>
              </vwui-table-row>
          }
        <vwui-table-row>
          <vwui-table-column></vwui-table-column>
          <vwui-table-column>
            <vwui-button class="is-secondary" (click)="openCreateQuestionModal(category)" [disabled]="!isConcept()">
              {{ 'COMPONENT.tis.create_question' | translate }}
            </vwui-button>
          </vwui-table-column>
          <vwui-table-column></vwui-table-column>
        </vwui-table-row>
      </vwui-table>
    </div>
  }
}
@if (categories) {
  <vwui-button class="is-secondary" (click)="openCreateCategoryModal()" [disabled]="!isConcept()">
    {{ 'COMPONENT.tis.create_category' | translate }}
  </vwui-button>
}
